import { useEffect } from "react";
import { Form, Divider, TimePicker, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { ReButton } from "@/components/refineElement";
import { getOptionArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { timeHrMin, currentTime, getMoment, dateFormat } from "@/lib/dateTime";
import { hasPermission } from "@/lib/permissionUtil";
import { TimePeriodType } from './types';

type Props = {
  form: any,
  info: TimePeriodType,
  handleType: string,
  clickDelete: (id: number) => void,
  intervalArray: TimePeriodType[],
}

function ModalInterval(props: Props) {
  const { form, info, handleType, clickDelete, intervalArray } = props;
  const { id } = info ?? {};
  const studentListT: any = getLangList("studentList");
  const busT: any = getLangList("bus");
  const buttonT: any = getLangList("button");

  const options = [
    { label: studentListT.FULL_DAY, value: 'Full Day' },
    { label: studentListT.PM, value: 'PM' },
    { label: studentListT.EVE, value: 'EVE' },
    { label: studentListT.LEAVED, value: 'LEAVE' },
  ];

  useEffect(() => {
    const { timePeriodName, startTime, endTime } = info ?? {};

    handleType === 'update' && form.setFieldsValue({
      timePeriodName,
      timeRange: [getMoment(`${currentTime.format(dateFormat)} ${startTime}`), getMoment(`${currentTime.format(dateFormat)} ${endTime}`)]
    });
  }, [form, info, handleType]);

  const getFinalOptions = () => {
    const { timePeriodName } = info ?? {};
    const optionNameArray = intervalArray.map((item) => item.timePeriodName);
    const finalOptions = options.filter((item) => timePeriodName === item.value || !optionNameArray.includes(item.value));

    return finalOptions;
  };

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item label={studentListT.INTERVAL} name="timePeriodName" rules={[{ required: true }]}>
        <Select showSearch filterOption={(input: any, option: any) => selectFilterOption(input, option)}>
          {getOptionArray(getFinalOptions())}
        </Select>
      </Form.Item>

      <Form.Item label={busT.TIME} name="timeRange" rules={[{ required: true }]}>
        <TimePicker.RangePicker format={timeHrMin} allowClear={false} />
      </Form.Item>

      {handleType === 'update' && hasPermission('ORGANIZATION_CLASS_MANAGEMENT_DELETE') &&
        <>
          <Divider dashed />
          <Form.Item label={buttonT.DELETE}>
            <ReButton onClick={clickDelete(id)} attributeObject={{ type: "danger" }} iconName='delete' />
          </Form.Item>
        </>
      }
    </Form >
  );
}

export default ModalInterval;